import Carousel from 'react-native-snap-carousel';
import { Component } from 'react';
import { View, Text, Image, Dimensions, Pressable } from 'react-native';
import { styles } from './carousel.styles';

const SLIDER_WIDTH = Dimensions.get('window').width - 15;
const ITEM_WIDTH = Math.round(SLIDER_WIDTH * 1) - 20;

export const MyCarousel = ({ events, navigation }) => {
	// const newEvents = events[0][0];
	const newEvents = events[0].map((event) => event[0]);

	const _renderItem = ({ item, index }) => {
		const days = ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'];
		let eventDate = new Date(`${item.event_date}T${item.event_time}`);

		return (
			// <View style={styles.recommendedSlider__container}>

			<Pressable
				key={item.id}
				onPress={() => {
					navigation.navigate('Event', {
						customEvent: item,
					});
				}}
			>
				<View style={styles.recommendedSlider__card}>
					<View style={styles.recommendedSlider__card__imageContainer}>
						<Image source={{ uri: item.img_big }} style={styles.recommendedSlider__card__image} />
						<View style={styles.recommendedSlider__overlay}>
							<Text style={styles.recommendedSlider__card__date}>{days[eventDate.getDay()]}</Text>
							<Text style={styles.recommendedSlider__card__time}>Kl {item.event_time}</Text>
							<Text style={styles.recommendedSlider__card__venue}>{item.venue}</Text>
							<Text style={styles.recommendedSlider__card__artist}>{item.artist}</Text>
						</View>
					</View>
				</View>
			</Pressable>
			// </View>
		);
	};

	return (
		<Carousel
			ref={(c) => {
				const _carousel = c;
			}}
			data={newEvents.slice(0, 5)}
			renderItem={_renderItem}
			sliderWidth={SLIDER_WIDTH}
			itemWidth={ITEM_WIDTH}
		/>
	);
};
